/**
 * Возвращает кастомный лейбл
 * для мнемоники аукциона
 * @param vas мнемоник
 */
export function getVasLabel(vas?: string) {
  return vas === 'auction' ? 'Премиум' : undefined;
}
